/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ReportScheduler {
    export interface IReportsHelper {
        reportNameToSecurityKey(reportName: string): string;
    }

    class ReportsHelper {
        static factory(): Function {
            const instance = () => {
                return new ReportsHelper();
            };

            instance.$inject = [];

            return instance;
        }

        public reportNameToSecurityKey(reportName: string): string {
            return reportName
                .replace(/ /g, '')
                .replace(/\-/g, '')
                .replace(/\//g, '')
                .toUpperCase();
        }
    }

    angular.module('meevo.plugins.reportScheduler')
        .factory('meevo.plugins.reportScheduler.ReportsHelper', ReportsHelper.factory());
}
